import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES } from '@gg/shared';
import { setLocale } from '@/lib/i18n';

/**
 * FR / EN switch (P-14), current language in `ink`, the other in `ink-subtle` (screen 05).
 * Shown on the checkout screens 01–03, login and the profile header.
 */
export function LanguageSwitch() {
  const { t, i18n } = useTranslation();
  return (
    <div role="group" aria-label={t('language.label')} className="flex justify-center gap-3.5">
      {SUPPORTED_LOCALES.map((l) => {
        const active = i18n.language === l;
        return (
          <button
            key={l}
            type="button"
            lang={l}
            aria-pressed={active}
            onClick={() => setLocale(l)}
            className={`text-sm uppercase ${active ? 'font-semibold text-ink' : 'text-ink-subtle hover:text-ink'}`}
          >
            {l}
          </button>
        );
      })}
    </div>
  );
}
